/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['uk-modal', nb.bind('modalName')],
        id: nb.bind('modalId'),
        $slot: 'body'
    },
    method: {
        init: function () {

        },
        onModelReady: function (inModel) {
            var $el = this.$();
            var modal = UIkit.modal($el);
            inModel.onChange('show', function () {
                modal.show();
            });
            inModel.onChange('hide', function () {
                modal.hide();
            });
            $el.on({
                'show.uk.modal': function () {
                    inModel.set('onShow', true, {skipSameValue: false});
                },
                'hide.uk.modal': function () {
                    inModel.set('onHide', true, {skipSameValue: false});
                }
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/Modal.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 32 34 35 36